// Thievery math helpers (SF-85) — mirror of shared/thievery/ThieveryMath.java
// Cross-language parity enforced via JSON fixture in shared/src/test/resources.

import type { DamageTier } from '../types/thievery';

export const DAMAGE_TIER_MULTIPLIER: Record<DamageTier, number> = {
  MINOR: 0.33,
  MEDIUM: 1.00,
  MASSIVE: 2.00,
};

// PREVIEW ONLY — backend uses live property values at execution time.
export const LOSS_RATE_BASE = {
  INTEL: 0.05,
  RESOURCE: 0.10,
  DESTRUCTIVE: 0.15,
  DURATION: 0.15,
} as const;

export const LOSS_RATE_MAX = 0.30;

// PREVIEW ASSUMPTION: target TPA ≈ 1.0 (same hack as estimateSuccessRate).
export const PREVIEW_TARGET_TPA = 1.0;

export function resolveDamageTier(
  totalThieves: number,
  baseCost: number,
  tier: DamageTier
): number {
  return Math.floor(totalThieves * baseCost * DAMAGE_TIER_MULTIPLIER[tier]);
}

export function estimateLossOnFailure(
  thievesSent: number,
  baseLossRate: number,
  attackerTPA: number,
  defenderTPA: number,
  maxLossRate: number
): number {
  if (attackerTPA <= 0) {
    return Math.floor(thievesSent * maxLossRate);
  }
  const defenderAdvantage = Math.max(1.0, defenderTPA / attackerTPA);
  const adjustedLossRate = Math.min(baseLossRate * defenderAdvantage, maxLossRate);
  return Math.floor(thievesSent * adjustedLossRate);
}
